import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Button from '../components/Button'
import styled from 'styled-components'
import { media } from '../theme'
import { setModalStatus } from '../modules/gameProgress'
import { removeItemsForRoom } from '../modules/itemInteractions'

const StyledButton = styled(Button)`
  bottom: 0;
  left: 50%;
  position: absolute;
  transform: translate(-50%, 50%);
  width: 60%;
  display: flex;
  ${media.greaterThan('medium')`    
    width: ${(p) => (p.size === 'large' ? '30%' : '25%')};
 `};
`

class PlayButton extends Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(e) {
    const { setModalStatus } = this.props
    const buttonUrl = this.props.startButtonUrl

    if (location.pathname === buttonUrl) {
      this.props.removeItemsForRoom(buttonUrl.slice(1))
    }

    if (buttonUrl === null) {
      e.preventDefault()
      alert('please select level')
    } else {
      setModalStatus(false)
    }
  }

  render() {
    const buttonCopy = this.props.buttonCopy
      ? this.props.buttonCopy
      : "Let's go"
    return (
      <StyledButton
        onClick={this.handleClick}
        to={this.props.startButtonUrl}
        size={this.props.size}
        props={this.props}
      >
        {buttonCopy}
      </StyledButton>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    startButtonUrl: state.gameProgress.startButtonUrl,
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setModalStatus, removeItemsForRoom }, dispatch)

const PlayButtonConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PlayButton)

export default PlayButtonConnected



// WEBPACK FOOTER //
// ./src/components/PlayButton.js